import { Button, Col, Container, Row } from 'react-bootstrap';
import { useAuth } from '../../Context/AuthProvider';
import CustomImage from '../../CommonComponents/CustomImage';
import Sidebar from './SideBar';
import RightComponent from './RightComponent';
import { useState, useEffect, useRef } from 'react';
import ChatComponent from './ChatComponent';
import { useSelector } from 'react-redux';
import Guest from '../../Asset/image/blank_profile.png';
import { loginItemsSelector } from '../../redux/slices/login';
import { deleteUser, getUserDetailService, isLoggedIn } from '../../services/userService';
import ApiConfig from '../../config/ApiConfig';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { LIMIT_DIGIT, paginationLimit, signUpType } from '../../data/constants';
import { getHistoryListService } from '../../services/chatService';
import MobileSidebar from './MobileSideBar';
import filterIcon from '../../Asset/image/filter.png';
import MobileRightComponent from './MobileRightSide';
import ProfileDropdown from './ProfileDropdown';

function Dashboard() {
  /* @ts-ignore */
  const { logout, setUser, user } = useAuth()
  const [show, setShow] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const handleDeleteAccount = () => setDeleteAccount(true);
  const handleShow = () => setShow(true);
  const handleLogoutShow = () => setLogoutShow(true);
  const mobRef = useRef();
  // const { user } = useSelector(loginItemsSelector);
  const [categoryKey, setCategoryKey] = useState("general");
  const [promptFilter, setPromptFilter] = useState("");
  const [replyLanguage, setReplyLanguage] = useState("");
  const [formality, setFormality] = useState("");
  const [tone, setTone] = useState("");
  const [userImage, setUserImage] = useState(Guest);
  const [mobileSideBar, setMobileSideBar] = useState(false);
  const [mobileRightSideBar, setMobileRightSideBar] = useState(false);
  const [profileShow, setProfileShow] = useState(false);
  const navigate = useNavigate();
  const handleProfileShow = () => setProfileShow(true);
  const [historyData, setHistoryData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (user?.signuptype == signUpType?.guest) {
      setHistoryData([]);
    }
    else {
      getList();
    }
  }, []);

  const getList = async () => {
    try {
      const params = {
        numberofdocs: paginationLimit,
        currentpage: page,
      };
      const response = await getHistoryListService(params);
      if (response?.data?.data) {
        const data =
          page === 1
            ? response?.data?.data
            : [...historyData, ...response?.data?.data];
        setHistoryData(data);
        page === 1 && setTotalData(response?.data?.totalCount);
      }
    } catch (err) {
      logout();
      console.log(err);
    }
  };
  const updateList = (history) => {
    const result = historyData?.filter((item) => item?._id !== history?._id);
    setHistoryData(result);
    setTotalData(totalData - 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    if (user?.profilePicture) {
      setUserImage(ApiConfig?.BASE_IMAGE_URL + user?.profilePicture + ".jpg" + "?" + new Date().getTime());
    }
    else {
      setUserImage("")
    }
  }, [user])
  const onDeleteAccount = async () => {
    try {
      const res = await deleteUser();
      if (res?.data) {
        toast.success(res?.data);
        logout();
      }
    } catch (error) {
      toast.error(error?.response?.data?.data);
      console.log(error, error?.response);
    }
  };
  /* Set the width of the sidebar to 250px (show it) */
  const openNav = () => {
    let cc = document.getElementById("mySidepanel");
    if (cc)
      cc.style.width = "250px";
    setMobileSideBar(true);
  }

  /* Set the width of the sidebar to 0 (hide it) */
  const closeNav = () => {
    setMobileSideBar(false)
    document.getElementById("mySidepanel").style.width = "0";
  }
  const openRightNav = () => {
    let cc = document.getElementById("myRightSidepanel");
    if (cc)
      cc.style.width = "250px";
    setMobileRightSideBar(true);
  }

  /* Set the width of the sidebar to 0 (hide it) */
  const closeRightNav = () => {
    setMobileRightSideBar(false)
    document.getElementById("myRightSidepanel").style.width = "0";
  }
  return (<>
    <div style={{ position: 'relative', height: "100vh", display: 'flex', flexDirection: "row", alignItems: "space-between", justifyContent: "between", paddingRight: "1px", backgroundColor: "#060B19" }}>
      <Row style={{ width: "100%" }}>
        {mobileSideBar === true ?
          <Col lg={3}>
            <MobileSidebar categoryKey={categoryKey} ref={mobRef} setCategoryKey={setCategoryKey} getList={getList} historyData={historyData} updateList={updateList} totalData={totalData} page={page} setPage={setPage} closeNav={closeNav} />
          </Col>
          :
          null
        }
        <Col lg={3} className="d-none d-lg-block">
          <Sidebar categoryKey={categoryKey} setCategoryKey={setCategoryKey} getList={getList} historyData={historyData} updateList={updateList} totalData={totalData} page={page} setPage={setPage} mobileSideBar={mobileSideBar} />
        </Col>
        <Col lg={6}>
          <div className="d-flex justify-content-between align-items-center ">
            <div className="d-flex justify-content-start align-items-center d-block d-lg-none" >
              <div><button className="openbtn " onClick={() => openNav()}>&#9776;</button></div>
              <div>
                <h2 style={{ color: "#fff", textTransform: "capitalize" }} >{categoryKey === "social_media" ? "Social Media" : categoryKey === "meeting_minute" ? "Meeting Minutes" : categoryKey}</h2>

              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center d-block d-lg-none" >
              <div>
                <CustomImage className="iconStyle" src={filterIcon} onClick={() => openRightNav()} /></div>
              <div> <ProfileDropdown show={show} setShow={setShow} logoutShow={logoutShow} setLogoutShow={setLogoutShow} deleteAccount={deleteAccount} setDeleteAccount={setDeleteAccount} profileShow={profileShow} setProfileShow={setProfileShow} onDeleteAccount={onDeleteAccount} handleProfileShow={handleProfileShow} handleDeleteAccount={handleDeleteAccount} handleLogoutShow={handleLogoutShow} userImage={userImage} /></div>
            </div>
          </div>
          <div style={{ marginLeft: "15px" }} onClick={() => {
            if (mobileSideBar === true)
              closeNav()
            if (mobileRightSideBar === true)
              closeRightNav()
          }}>
            <h2 className="d-none d-lg-block" style={{ color: "#fff", marginTop: "22px", textTransform: "capitalize" }} >{categoryKey === "social_media" ? "Social Media" : categoryKey === "meeting_minute" ? "Meeting Minutes" : categoryKey}</h2>
            <p className='commentText'>Provides results related to <span>{categoryKey === "social_media" ? "social media" : categoryKey === "meeting_minute" ? "meeting minutes" : categoryKey}</span></p>
            <div className="chatBox">
              <ChatComponent categoryKey={categoryKey} promptFilter={promptFilter} replyLanguage={replyLanguage} tone={tone} formality={formality} getList={getList} />
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className="d-none d-lg-block">
            <ProfileDropdown show={show} setShow={setShow} logoutShow={logoutShow} setLogoutShow={setLogoutShow} deleteAccount={deleteAccount} setDeleteAccount={setDeleteAccount} profileShow={profileShow} setProfileShow={setProfileShow} onDeleteAccount={onDeleteAccount} handleProfileShow={handleProfileShow} handleDeleteAccount={handleDeleteAccount} handleLogoutShow={handleLogoutShow} userImage={userImage} /></div>
          {mobileRightSideBar === true ?
            <MobileRightComponent promptFilter={promptFilter} setPromptFilter={setPromptFilter} replyLanguage={replyLanguage} setReplyLanguage={setReplyLanguage} tone={tone} setTone={setTone} formality={formality} setFormality={setFormality} openNav={openRightNav} closeNav={closeRightNav} />
            :
            null
          }
          <RightComponent promptFilter={promptFilter} setPromptFilter={setPromptFilter} replyLanguage={replyLanguage} setReplyLanguage={setReplyLanguage} tone={tone} setTone={setTone} formality={formality} setFormality={setFormality} />
        </Col>

      </Row>

    </div>
  </>)
}

export default Dashboard;
